module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub-down--.e50875c2.svg";